import { render, staticRenderFns } from "./NewAdminDashbord.vue?vue&type=template&id=3a35a33a"
import script from "./NewAdminDashbord.vue?vue&type=script&lang=js"
export * from "./NewAdminDashbord.vue?vue&type=script&lang=js"
import style0 from "./NewAdminDashbord.vue?vue&type=style&index=0&id=3a35a33a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports